<template>
  <div class="acclaro-editable-cell">
    <div class="aec-input">

      <div v-if="isTextInput">
        <div v-if="!isEditing()">
          <span class="ellipsis" v-if="revertValue && revertValue.length > 12"
                v-tooltip="content">{{content}}</span>
          <span class="ellipsis" v-else>{{content || '-'}}</span>
        </div>
        <input v-else v-model="value" placeholder="-" type="text"/>
      </div>

      <div v-else>
        <span v-if="!isEditing()" class="ellipsis">{{content && content != '0.00' ? ('$' + numberWithCommas(parseFloat(content).toFixed(2))) : '-'}}</span>
        <span v-else>
          <input v-if="isTextInput" v-model="value" placeholder="-" type="text"/>
          <input v-else v-model="value" step='0.01' placeholder="0.00" type="number"/>
        </span>
      </div>
    </div>
    <div class="aec-controls">
      <div v-if="isEditing()">
        <close-icon class="clickable" :size="17" v-on:click="revertValue();valueReverted();setEditing(false);"/>
        <content-save-icon
            class="clickable"
            :size="17"
            v-on:click="update(value);$emit('updated', {id: props.row.id, value, column: updateColumn});setEditing(false);"/>
      </div>
      <pencil-icon v-else class="clickable" :size="17" v-on:click="setEditing(true);"/>
    </div>
  </div>
</template>


<script>
  import {
    PencilIcon,
    CloseIcon,
    ContentSaveIcon
  } from '../../icons.js';

  export default {
    name: 'AsStatus',
    props: {

      props: {
        type: [Array, Object],
        required: true,
      },

      isTextInput: {
        type: Boolean,
        default: false
      },

      updateColumn: {
        type: [String,Number],
        default: ''
      }
    },

    watch: {

      content: function (val) {
        this.value = val;
      }
    },

    computed: {

      content () {
        let { row, column } = this.props;
        let rowContent = row ? row[column] : this.state.initialValue || null;

        return rowContent;
      }
    },
    methods: {
      numberWithCommas(x) {
        return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      },

      valueReverted () {
        this.value = this.content;
      },

      setEditing (bol) {
        return this.state.isEditing = bol;
      },

      isEditing () {
        return this.state.isEditing;
      },

      revertValue () {
        return this.value = this.state.initialValue;
      },

      update (val) {
        this.value = val;
        this.state.initialValue = val;
      }
    },

    data () {
      return {
        value: this.props.row[this.props.column],
        state: {
          isEditing: false,
          initialValue: this.props.row[this.props.column]
        }
      };
    },

    components: {
      PencilIcon,
      CloseIcon,
      ContentSaveIcon
    },
  };
</script>

<style>
.acclaro-editable-cell {
  display: flex;
  max-width: 120px;
}

.acclaro-editable-cell .aec-controls {
  width: 55px;
  padding-left: 10px;
  box-sizing: border-box;
  text-align: right;
}

.acclaro-editable-cell .aec-input {
  flex: 1 auto;
  min-width: 100px;
  height: 19px;
}

.acclaro-editable-cell .aec-input input {
  width: 100%;
}
</style>
